import { render, staticRenderFns } from "./DefaultCell.vue?vue&type=template&id=52095262&scoped=true&"
import script from "./DefaultCell.vue?vue&type=script&lang=js&"
export * from "./DefaultCell.vue?vue&type=script&lang=js&"
import style0 from "./DefaultCell.vue?vue&type=style&index=0&id=52095262&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52095262",
  null
  
)

export default component.exports